var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoConstructInfoHideLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.2C15.081 19.2 19.2 15.081 19.2 10C19.2 4.91898 15.081 0.8 10 0.8C4.91898 0.8 0.8 4.91898 0.8 10C0.8 15.081 4.91898 19.2 10 19.2Z",
    stroke: "#5C5C5C",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.20711L7.73162 11.8536C7.56425 12.0488 7.29289 12.0488 7.12553 11.8536C6.95816 11.6583 6.95816 11.3417 7.12553 11.1464L9.69695 8.14645C9.86432 7.95118 10.1357 7.95118 10.303 8.14645L12.8745 11.1464C13.0418 11.3417 13.0418 11.6583 12.8745 11.8536C12.7071 12.0488 12.4358 12.0488 12.2684 11.8536L10 9.20711Z",
    fill: "#565656"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_1344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 6,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.20711L7.73162 11.8536C7.56425 12.0488 7.29289 12.0488 7.12553 11.8536C6.95816 11.6583 6.95816 11.3417 7.12553 11.1464L9.69695 8.14645C9.86432 7.95118 10.1357 7.95118 10.303 8.14645L12.8745 11.1464C13.0418 11.3417 13.0418 11.6583 12.8745 11.8536C12.7071 12.0488 12.4358 12.0488 12.2684 11.8536L10 9.20711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_1344)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConstructInfoHideLight);
export default __webpack_public_path__ + "static/media/ico-construct-info-hide-light.ee782c0a6a371e673721a29ee1d5f551.svg";
export { ForwardRef as ReactComponent };